<template>
  <div>

    <el-row :gutter="8">
      <!-- Date range picker -->
      <el-col :span="12">
        <el-card shadow="never">
          <div class="d-flex justify-space-between">
            <el-date-picker type="daterange" v-model="pickedDates"
              range-separator="～" start-placeholder="開始日期" end-placeholder="結束日期"
              :picker-options="datePickerOptions">
            </el-date-picker>
            <el-button type="primary" circle icon="now-ui-icons ui-1_zoom-bold"
              @click="onDateRangeChange" class="ml-4">
            </el-button>
            <!-- Transfer sheet exports -->
            <el-button round type="danger" icon="now-ui-icons arrows-1_cloud-download-93"
              @click="exportTransferSheet" class="mx-4">
              下載匯款表（ACH）
            </el-button>
          </div>
        </el-card>
      </el-col>

      <!-- <el-col :span="16"></el-col> -->
    </el-row>

    <br>

    <el-row>
      <!-- LIST OF SUMMARIZED SHOPS w/ Bank Accounts-->
      <el-col :span="24">
        <el-card shadow="never">
          <h5>代收店家列表／總帳</h5>
          <h6>應付店家 = 代收訂單總金額 - 代收支付手續費 - 代理物流費 + 加減項</h6>
          <SSRTable :data-url="urlSummaries" :schema="table.summaries.cols" data-key="summaries"
            :search-on="['account_id', 'account_name']">
            <div slot="shop_name" slot-scope="{row}">
              {{ row.shop_id }} - {{ row.shop_name }}
            </div>
            <div slot="total" slot-scope="{row}">
              ${{ Number(row.total).toLocaleString() }}
            </div>
            <div slot="logistics" slot-scope="{row}">
              ${{ Number(row.logistics).toLocaleString() }}
            </div>
            <div slot="transaction_fee" slot-scope="{row}">
              ${{ Number(row.transaction_fee).toLocaleString() }}
            </div>
            <div slot="surcharge" slot-scope="{row}">
              ${{ Number(row.surcharge).toLocaleString() }}
            </div>
            <div slot="to_shop" slot-scope="{row}">
              ${{ Number(row.to_shop).toLocaleString() }}
            </div>
            <div slot="bank_name" slot-scope="{row}">
              <a href="#" @click="showBankAccountInfo(row)">{{ row.bank_name }}</a>
            </div>
            <div slot="actions" slot-scope="{row}">
              <el-button round type="info" size="mini" icon="el-icon-notebook-1"
                @click="showLedgerOfShop(row)">
                代收訂單列表
              </el-button>
              <el-button round type="warning" size="mini" icon="el-icon-download"
                @click="exportSingleShopSummary(row)">
                匯出報表
              </el-button>
            </div>
          </SSRTable>
        </el-card>
      </el-col>

    </el-row>

    <el-dialog :title="`帳目／訂單列表：${dialog.ledger.shopName}`"
      :visible.sync="dialog.ledger.show" width="60%">

      <SSRTable :data-url="urlShopLedger" :schema="table.ledger.cols"
        data-key="records">
        <div slot="order_id" slot-scope="{row}">
          <span>{{ row.scheduled_at }}</span><br>
          <small>{{ row.order_id }}</small>
        </div>
        <div slot="amount" slot-scope="{row}">
          <span>${{ Number(row.amount).toLocaleString() }}</span>
        </div>
        <div slot="discount" slot-scope="{row}">
          <span>${{ Number(row.discount).toLocaleString() }}</span>
        </div>
        <div slot="logistics" slot-scope="{row}">
          <span>${{ Number(row.logistics).toLocaleString() }}</span>
        </div>
        <div slot="transaction_fee" slot-scope="{row}">
          <span>${{ Number(row.transaction_fee).toLocaleString() }}</span>
        </div>
        <div slot="surcharge" slot-scope="{row}">
          <span>${{ Number(row.surcharge).toLocaleString() }}</span>
        </div>
        <div slot="refunded" slot-scope="{row}">
          <span style="color: red;" v-if="row.refunded > 0">
            ${{ row.refunded }}
            <br>
            {{ row.refunded_at }}
          </span>
          <span v-else></span>
        </div>
        <div slot="refunded_at" slot-scope="{row}">
          <span style="color: red;">{{ row.refunded_at }}</span>
        </div>
        <div slot="useProxyPayService" slot-scope="{row}">
          <i class="el-icon-circle-check" v-if="row.useProxyPayService === true"></i>
        </div>
      </SSRTable>
    </el-dialog>
  </div>
</template>

<script>
// import DataTable from 'src/components/DataTable';
import SSRTable from 'src/components/SSRTable';

import moment from 'moment';

export default {
  components: {
    // DataTable,
    SSRTable
  },

  mounted() {

  },

  methods: {
    onDateRangeChange() {
      
    },

    showBankAccountInfo(summary) {
      alert(`
        Bank: ${summary['bank_name']},
        Bank ID: ${summary['bank_id']},
        Account: ${summary['account_name']},
        Account No: ${summary['account_no']}
      `);
    },

    showLedgerOfShop(summary) {
      this.dialog.ledger.shopId = summary['shop_id'];
      this.dialog.ledger.shopName = summary['shop_name'];
      this.dialog.ledger.show = true;
    },

    exportSingleShopSummary(summary) {
      let shopId = summary['shop_id'];
      let from = moment(this.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.pickedDates[1]).format('YYYYMMDD');
      window.open(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shopId}/report`
        + `?from=${from}&to=${to}`
      );
    },

    exportTransferSheet() {
      let from = moment(this.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.pickedDates[1]).format('YYYYMMDD');
      window.open(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/ledger/ach-sheet`
        + `?from=${from}&to=${to}`
      );
    }

  },

  data() {
    return {

      pickedDates: [
        moment().add(-1, 'weeks').startOf('isoWeek').toDate(),
        moment().add(-1, 'weeks').endOf('isoWeek').toDate()
      ],

      dialog: {
        ledger: {
          show: false,
          shopId: 0,
          shopName: ''
        }
      },
      table: {
        summaries: {
          data: [],
          cols: [
            // { key: 'shop_id', label: '#', sortable: true, width: 84 },
            { key: 'shop_name', label: '店家', sortable: true, width: 192 },
            { key: 'num_of_orders_proxied', label: '代收訂單數', align: 'right' },
            { key: 'total', label: '總金額', align: 'right' },
            { key: 'logistics', label: '代理物流費', align: 'right' },
            { key: 'transaction_fee', label: '手續費', align: 'right', width: 160, sortable: true },
            { key: 'surcharge', label: '加減項', align: 'right' },
            { key: 'to_shop', label: '應付店家', align: 'right' },
            { key: 'bank_name', label: '收款人帳戶', align: 'center' },
            { key: 'actions', label: '', width: 360 }
          ]
        },
        ledger: {
          data: [],
          cols: [
            { key: 'order_id', label: '交易時間', sortable: true, width: 160 },
            // { key: 'scheduled_at', label: '交易時間', sortable: true },
            { key: 'amount', label: '訂單金額', align: 'right', width: 120 },
            { key: 'discount', label: '優惠', align: 'right', width: 120 },
            { key: 'logistics', label: '代理物流費', align: 'right', width: 120 },
            { key: 'transaction_fee', label: '手續費', align: 'right', width: 120 },
            { key: 'surcharge', label: '加減', align: 'right', width: 120 },
            { key: 'refunded', label: '退款', width: 160 },
            // { key: 'refunded_at', label: '退款時間' },
            { key: 'useProxyPayService', label: '代收付？', align: 'center' },
            // { key: 'actions', label: '' }
          ]
        }
      },

      datePickerOptions: {
        shortcuts: [{
          text: ' 本週',
          onClick(picker) {
            picker.$emit('pick', [
              moment().startOf('isoWeek').toDate(),
              moment().endOf('day').toDate()
            ]);
          }
        }, {
          text: '上週',
          onClick(picker) {
            picker.$emit('pick', [
              moment().add(-1, 'weeks').startOf('isoWeek').toDate(),
              moment().add(-1, 'weeks').endOf('isoWeek').toDate()
            ]);
          }
        }, {
          text: '上上週',
          onClick(picker) {
            picker.$emit('pick', [
              moment().add(-2, 'weeks').startOf('isoWeek').toDate(),
              moment().add(-2, 'weeks').endOf('isoWeek').toDate()
            ]);
          }
        }]
      }

    }
  },

  computed: {
    urlSummaries() {
      let from = moment(this.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.pickedDates[1]).format('YYYYMMDD');
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/ledger/preview?from=${from}&to=${to}`;
    },
    urlShopLedger() {
      if (!this.dialog.ledger.shopId) return null;

      let from = moment(this.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.pickedDates[1]).format('YYYYMMDD');
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops`
        + `/${this.dialog.ledger.shopId}/ledger?from=${from}&to=${to}`
        + `&timeFormat=${encodeURIComponent('YYYY/M/D H:mm:ssA')}`;
    },

    pickedDateRangeText() {
      return `${moment(this.pickedDates[0]).format('YYYY/MM/DD')}～${moment(this.pickedDates[1]).format('YYYY/MM/DD')}`;
    },

    userType() {
      return this.$store.getters.userType;
    }
  }


}
</script>

<style>
/* So that text and carets in <th> align each other */
/*
th div.cell {
  display: flex !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
*/
</style>